<script>
const lodashOrderBy = require('lodash/orderBy');
import moment from 'moment';
import LiFile from './LiFile.vue';
export default {
  props: ['urlToService', 'Settings', 'componentTexts', 'iconPaths'],
  components: { LiFile },
  data() {
    return {
      directories: [],
      files: [],
      sortByName: false,
      sortByDate: false,
      lastUsedMediaFolderReferenceId: [],
      currentFolderId: '',
      folderIndex: 0,
      pdf: this.iconPaths.pdf,
      doc: this.iconPaths.doc,
      ppt: this.iconPaths.ppt,
      xls: this.iconPaths.xls,
      file: this.iconPaths.file,
      loading: false,
      title: '',
      sortDateAsc: false,
      hasClickedSort: false,
      sortOrder: '',
    };
  },
  mounted() {
    debugger;
    if (this.urlToService && this.Settings) {
      let req = this.Settings;
      debugger;
      this.showDate = this.Settings.Settings.Columns.includes("Changed");
      this.fetchData(this.urlToService, req);
      let sortOrder = req.Settings.sortOrder;
      if (sortOrder && sortOrder == 'descending') {
        this.sortByNameFunc();
      }
      if (this.Settings) {
        let obj = this.Settings;
        if (obj.Settings && obj.Settings.ListHeading) {
          this.title = obj.Settings.ListHeading;
        }
      }
    }
  },
  methods: {
    async fetchData(url, req, lastreqid) {
      if (lastreqid) {
        if (!this.lastUsedMediaFolderReferenceId.includes(lastreqid)) {
          this.lastUsedMediaFolderReferenceId.push(lastreqid);
        }
      }
      try {
        this.loading = true;
        await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: 'RequestPackageType=' + encodeURIComponent(JSON.stringify(req)),
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.Files && response.Files.length > 0) {
              response.Files.map((file) => {
                file.Created = moment(file.Changed).format('YYYY-MM-DD');
              });
              this.files = response.Files;
            } else if (response.Files && response.Files.length < 1) {
              this.files = response.Files;
            }
            if (response.Directories && response.Directories.length > 0) {
              this.directories = response.Directories;
            } else if (
              response.Directories &&
              response.Directories.length < 1
            ) {
              this.directories = response.directories;
            }
            this.currentFolderId = req.Settings.MediaFolderReferenceId;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    clickedFile(val) {},
    goBack() {
      this.folderIndex--;
      let req = this.Settings;
      let goToIndex = this.lastUsedMediaFolderReferenceId.pop();
      req.Settings.MediaFolderReferenceId = goToIndex;
      req.Settings.CurrentMediaFolderReferenceId = goToIndex;
      this.fetchData(this.urlToService, req);
    },
    async clickedFolder(val) {
      this.folderIndex++;
      let req = this.Settings;
      req.Settings.MediaFolderReferenceId = val;
      req.Settings.CurrentMediaFolderReferenceId = val;

      this.fetchData(this.urlToService, req, this.currentFolderId);
    },
    sortByNameFunc() {
      this.hasClickedSort = false;
      this.sortByName = !this.sortByName;
      if (this.sortByName) {
        this.sortByDate = false;
      }
    },
    sortByDateFunc() {
      this.sortByDate = !this.sortByDate;
      if (this.sortByDate) {
        this.sortByName = false;
        this.hasClickedSort = true;
      }
    },
  },
  computed: {
    sortedDirectories() {
      if (this.sortByName && this.directories && this.directories.length > 0) {
        let tempDir = this.directories.slice(0);
        return lodashOrderBy(tempDir, 'Name', ['desc']);
      } else {
        if (this.directories) {
          return this.directories;
        }
      }
    },
    sortedFiles() {
      if (this.sortByName && this.files && this.files.length > 0) {
        let tempFiles = this.files.slice(0);
        return lodashOrderBy(tempFiles, 'Name', ['desc']);
      } else if (this.sortByDate && this.files && this.files.length > 0) {
        let tempFiles = this.files.slice(0);
        return lodashOrderBy(tempFiles, 'Created', ['desc']);
      } else if (!this.sortByDate && this.files && this.files.length > 0) {
        let tempFiles = this.files.slice(0);
        return lodashOrderBy(tempFiles, 'Created', ['asc']);
      } else {
        if (this.files) {
          return this.files;
        }
      }
    },
    mixedFolderAndFilesArray() {
      let files = this.files;
      let directories = this.directories;
      let filesAndFolders;

      if (files && directories) {
        filesAndFolders = [...files, ...directories];
      } else if (!files && directories) {
        filesAndFolders = [...directories];
      } else if (!directories && files) {
        filesAndFolders = [...files];
      } else if (!directories && !files) {
        return null;
      }

      if (this.sortByName && filesAndFolders.length > 0) {
        return lodashOrderBy(filesAndFolders, ['Name'], ['desc']);
      } else if (this.sortByDate && files.length > 0) {
        let tempDir = lodashOrderBy(filesAndFolders, ['Created'], ['desc']);
        return tempDir;
      } else if (this.hasClickedSort && !this.sortByName && files.length > 0) {
        let tempDir = lodashOrderBy(filesAndFolders, ['Created'], ['asc']);
        return tempDir;
      }
      return lodashOrderBy(filesAndFolders, ['Name'], ['asc']);
    },
  },
};
</script>

<template>
  <div class="row librarybrowserblock vld-parent">
    <div class="col-12" v-if="title">
      <h2 class="heading-level-2 title-container">{{ title }}</h2>
    </div>

    <vloading
      :height="35"
      :width="35"
      :color="'#404040'"
      :is-full-page="false"
      :active.sync="loading"></vloading>

    <div class="col-12">
      <div
        class="d-flex flex-row justify-content-between align-items-center action--items">
        <button class="sort--items" @click="sortByNameFunc" key="1">
          <span v-if="componentTexts.sortNameText.value">
            {{ componentTexts.sortNameText.value }}
          </span>
          <transition name="fade" mode="out-in">
            <i key="1" v-if="sortByName" class="material-icons">keyboard_arrow_up</i>
            <i key="2" v-else class="material-icons">keyboard_arrow_down</i>
          </transition>
        </button>
        <transition name="fade" mode="out-in">
          <button
            class="sort--items"
            @click="sortByDateFunc"
            key="1"
            :class="{ 'cant-sort-by-date': files.length < 1 }">
            <span v-if="componentTexts.sortDateText.value">
              {{ componentTexts.sortDateText.value }}
            </span>
            <transition name="fade" mode="out-in">
              <i key="1" v-if="sortByDate" class="material-icons"
                >keyboard_arrow_up</i
              >
              <i key="2" v-else class="material-icons">keyboard_arrow_down</i>
            </transition>
          </button>
        </transition>
      </div>
    </div>

    <div class="col-12" v-if="folderIndex > 0 && !loading">
      <button class="go--back" @click="goBack">
        <i class="material-icons" aria-hidden="true">folder_open</i>
        <span aria-hidden="true"> ... </span>
        <span class="sr-only">Backa i mappstrukturen</span>
      </button>
    </div>

    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <ul class="list-unstyled d-flex flex-column file--items">
            <LiFile
              v-for="(item, index) in mixedFolderAndFilesArray"
              :key="index"
              :item="item"
              :pdf="pdf"
              :doc="doc"
              :ppt="ppt"
              :xls="xls"
              :file="file"
              :name="item.Name"
              :showDate = "this.showDate"
              :url="item.IconUrl"
              :fullUrl="item.FullUrl"
              :date="item.Created"
              :referenceId="item.MediaFolderReferenceId"
              :extension="item.Extension"
              @clickedFile="clickedFile"
              @clickedFolder="clickedFolder">
            </LiFile>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
